module.exports = __webpack_public_path__ + "static/media/background.7f281908.png";